import { useAuthStore } from '../../stores/authStore';
import { ThemeToggle } from '../ui/ThemeToggle';
import { LocaleSelector } from '../ui/LocaleSelector';
import { useLayoutStore } from '../../stores/layoutStore';
import { UserAvatarMenu } from './UserAvatarMenu';
import { SessionContextHeader } from './SessionContextHeader';

/**
 * Header/Topbar component matching mockup-1 exactly.
 * Sprint 31.7: Rewritten to match .topbar pattern using CSS classes.
 * Sprint 31.9 Phase 11: Updated for Identity Center with session context.
 * - Sticky at top, z-index 40
 * - padding-left: 280px (20px when compact/sidebar collapsed)
 * - Hamburger button to toggle sidebar
 * - Session context and user avatar on right side
 */
export function Header() {
  const { isAuthenticated } = useAuthStore();
  const { sidebarCollapsed, toggleSidebar } = useLayoutStore();

  return (
    <header className={`topbar ${sidebarCollapsed ? 'compact' : ''}`}>
      {/* Left side - hamburger button */}
      <div className="topbar-left">
        <button
          onClick={toggleSidebar}
          className="hamburger-btn"
          aria-label={sidebarCollapsed ? 'Open sidebar' : 'Close sidebar'}
          title={sidebarCollapsed ? 'Open sidebar' : 'Close sidebar'}
        >
          {/* Hamburger icon - 3 lines */}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <rect x="2" y="3" width="12" height="1.5" rx="0.5" />
            <rect x="2" y="7" width="12" height="1.5" rx="0.5" />
            <rect x="2" y="11" width="12" height="1.5" rx="0.5" />
          </svg>
        </button>
      </div>

      {/* Right side - theme toggle, session context, user menu */}
      <div className="topbar-right">
        {/* Theme toggle (compact mode for header) */}
        <ThemeToggle compact />

        {/* Locale selector - Sprint 10.3 */}
        <LocaleSelector />

        {/* Session context display - Sprint 31.9 Phase 11 */}
        {isAuthenticated && <SessionContextHeader />}

        {/* User avatar menu - Sprint 31.9 Phase 11 */}
        {isAuthenticated && <UserAvatarMenu />}
      </div>
    </header>
  );
}
